// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"ea45cff7","228":"a78e4105","398":"cad0d31b","517":"eaedfe16","734":"e1baed06","751":"374a6a73","825":"ba775f9a","917":"4d855110","959":"9dbb021a"}[chunkId] + ".chunk.js";
};